import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../../../../constant';
import * as actions from '../../../../action';

function UpdateDetailsModal({
  updateDetails,
  getDetailsList,
  updateList,
  detailsId,
  newTaxRevenuesId,
  calculationsId,
  updating,
}) {
  const [formData, setFormData] = useState({
    amount: '',
    rate: '',
  });

  const validateForm = useFormValidator(formData, {
    amount: 'required|amount_zero',
    rate: 'required|less_than_1',
  });
  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    updateDetails(newTaxRevenuesId, calculationsId, detailsId, formData, () => {
      setModal({ isOpen: false });
      getDetailsList(newTaxRevenuesId, calculationsId);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        amount: _.get(updateList, 'amount').toString(),
        rate: _.get(updateList, 'rate').toString(),
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA_DETAILS)));
    }
  };

  useEffect(() => {
    onSetFormData();
  }, []);

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            <input
              className="form-control"
              type="number"
              name="amount"
              onChange={onChange}
              placeholder="Ex. 0.00"
              value={_.get(formData, 'amount')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Rate: {validateForm.renderMessage('rate')}
            </label>
            <input
              className="form-control"
              type="number"
              name="rate"
              onChange={onChange}
              placeholder="Ex. 0.1234"
              value={_.get(formData, 'rate')}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateDetailsModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  updateDetails: PropTypes.instanceOf(Function).isRequired,
  getDetailsList: PropTypes.instanceOf(Function).isRequired,
  detailsId: PropTypes.string.isRequired,
  newTaxRevenuesId: PropTypes.string.isRequired,
  calculationsId: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_DETAILS_LICENSE) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateDetailsModal);
